import { render, staticRenderFns } from "./PublicShareSidebar.vue?vue&type=template&id=cdb03f3a&scoped=true"
import script from "./PublicShareSidebar.vue?vue&type=script&lang=js"
export * from "./PublicShareSidebar.vue?vue&type=script&lang=js"
import style0 from "./PublicShareSidebar.vue?vue&type=style&index=0&id=cdb03f3a&prod&lang=css"
import style1 from "./PublicShareSidebar.vue?vue&type=style&index=1&id=cdb03f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb03f3a",
  null
  
)

export default component.exports